module.exports = __webpack_public_path__ + "img/11.d2b2278a.jpg";